const viewRoles = (state = [], action) => {
  switch (action.type) {
    case "viewRoles":
      return action.payload;
    default:
      return state;
  }
};

export default viewRoles;
